<div class="container">
  <h3 i18n>Leite zu Anfrage weiter...</h3>
  <mat-spinner></mat-spinner>
</div>
